import React, { useState } from "react";
import MediaQuery from "react-responsive";
import { Scrollbar } from "react-scrollbars-custom";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import { InlineMath } from "react-katex";
import Iframe from "react-iframe";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import Marimencoba from "./Marimencoba.js";
import Ctp from "./Ctp.js";
import Lt1 from "../NilaiOptimum/111.png";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import VideoPlayer from "react-video-js-player";
import Caratp from "./caraTP.mp4"
import "../Programlinear/1/Part1.css"
const useStyles = makeStyles((theme) => ({
	appBar: {
		position: "relative",
		backgroundColor: "#4775d1",
	},
	title: {
		margin: "auto",
	},
}));

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});
const Part2 = () => {
	const [openDialog, setOpenDialog] = useState(false);
	const handleClickOpenDialog = () => {
		setOpenDialog(true);
	  };
	
	  const handleCloseDialog = () => {
		setOpenDialog(false);
	  };
	const classes = useStyles();
	const [chsoal0, setChsoal0] = useState(false);
	const clickSetChSoal0 = () => setChsoal0(!chsoal0);
	const [chsoal1, setChsoal1] = useState(false);
	const [jawaban1, setJawaban1] = useState(false);
	const clickSetJawaban1 = () => setJawaban1(!jawaban1);
	const clickSetChSoal1 = () => setChsoal1(!chsoal1);

	const [openmencobadialog, setOpenmencobadialog] = useState(false);
	const openMencobaDialog = () => {
		setOpenmencobadialog(true);
	};
	const closemencobaDialog = () => {
		setOpenmencobadialog(false);
	};
	const [show1, setShow1] = useState(false);
	const [show2, setShow2] = useState(false);
	const [show3, setShow3] = useState(false);
	const [show4, setShow4] = useState(false);
	const [show5, setShow5] = useState(false);
	const [show6, setShow6] = useState(false);
	const [show7, setShow7] = useState(false);
	const [show8, setShow8] = useState(false);
	const [show8a, setShow8a] = useState(false);
	const [show9, setShow9] = useState(false);
	const [show10, setShow10] = useState(false);
	const [show11, setShow11] = useState(false);
	const [form1, setForm1] = useState({ width: "50px", height: "30px" });
	const [form2, setForm2] = useState({ width: "50px", height: "30px" });
	const [form3, setForm3] = useState({ width: "70px", height: "30px" });
	const [form4, setForm4] = useState({ width: "50px", height: "30px" });
	const [form5, setForm5] = useState({ width: "50px", height: "30px" });
	const [form6, setForm6] = useState({ width: "70px", height: "30px" });
	const [form7, setForm7] = useState({ width: "50px", height: "30px" });
	const [form8, setForm8] = useState({ width: "50px", height: "30px" });
	const [form9, setForm9] = useState({ width: "70px", height: "30px" });
	const [form10, setForm10] = useState({ width: "50px", height: "30px" });
	const [form11, setForm11] = useState({ width: "50px", height: "30px" });
	const [form12, setForm12] = useState({ width: "70px", height: "30px" });
	const [form13, setForm13] = useState({ width: "50px", height: "30px" });
	const [form14, setForm14] = useState({ width: "50px", height: "30px" });
	const [form14a, setForm14a] = useState({ width: "70px", height: "30px" });
	const [form15, setForm15] = useState({ width: "50px", height: "30px" });
	const [form16, setForm16] = useState({ width: "50px", height: "30px" });
	const [form17, setForm17] = useState({ width: "50px", height: "30px" });

	//baru9januari2022
	const [shownew1, setShownew1] = useState(false);
	const [shownew2, setShownew2] = useState(false);
	const [shownew3, setShownew3] = useState(false);
	const [shownew4, setShownew4] = useState(false);
	const [shownew5, setShownew5] = useState(false);
	const [shownew6, setShownew6] = useState(false);
	const [shownew7, setShownew7] = useState(false);
	const [shownew8, setShownew8] = useState(false);
	const [shownew8a, setShownew8a] = useState(false);
	const [shownew8b, setShownew8b] = useState(false);
	const [shownew9, setShownew9] = useState(false);
	const [shownew9a, setShownew9a] = useState(false);
	const [shownew10, setShownew10] = useState(false);
	
	const [new1, setNew1] = useState({ width: "50px", height: "30px" });
	const [new2, setNew2] = useState({ width: "50px", height: "30px" });
	const [new3, setNew3] = useState({ width: "50px", height: "30px" });
	const [new4, setNew4] = useState({ width: "50px", height: "30px" });
	const [new5, setNew5] = useState({ width: "50px", height: "30px" });
	const [new6, setNew6] = useState({ width: "50px", height: "30px" });
	const [new7, setNew7] = useState({ width: "50px", height: "30px" });
	const [new8, setNew8] = useState({ width: "50px", height: "30px" });
	const [new8a, setNew8a] = useState({ width: "70px", height: "30px" });
	const [new8b, setNew8b] = useState({ width: "70px", height: "30px" });
	const [new8c, setNew8c] = useState({ width: "70px", height: "30px" });
	const [new9, setNew9] = useState({ width: "50px", height: "30px" });
	const [new9a, setNew9a] = useState({ width: "50px", height: "30px" });
	const [new10, setNew10] = useState({ width: "50px", height: "30px" });
	
	//1maret22
	const [new11, setNew11] = useState({ width: "75px", height: "30px" });
	const [new12, setNew12] = useState({ width: "75px", height: "30px" });
	const [new13, setNew13] = useState({ width: "75px", height: "30px" });
	const [new14, setNew14] = useState({ width: "50px", height: "30px" });
	const [shownew11, setShownew11] = useState(false);
	const [shownew12, setShownew12] = useState(false);
	const [shownew13, setShownew13] = useState(false);
	const handlenew11 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "255000") {
			setNew11({
				border: "6px solid #1aff66",
				width: "80px",
				height: "30px",
			});
			setShownew11(true);
		} else if (jwb === "") {
			setNew11({
				border: "6px solid yellow",
				width: "80px",
				height: "30px",
			});
		} else {
			setNew11({
				border: "6px solid red",
				width: "80px",
				height: "30px",
			});
		}
	};
	const handlenew12 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "225000") {
			setNew12({
				border: "6px solid #1aff66",
				width: "80px",
				height: "30px",
			});
			setShownew12(true);
		} else if (jwb === "") {
			setNew12({
				border: "6px solid yellow",
				width: "80px",
				height: "30px",
			});
		} else {
			setNew12({
				border: "6px solid red",
				width: "80px",
				height: "30px",
			});
		}
	};
	const handlenew13 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "125000") {
			setNew13({
				border: "6px solid #1aff66",
				width: "75px",
				height: "30px",
			});
			setShownew13(true);
		} else if (jwb === "") {
			setNew13({
				border: "6px solid yellow",
				width: "75px",
				height: "30px",
			});
		} else {
			setNew13({
				border: "6px solid red",
				width: "75px",
				height: "30px",
			});
		}
	};
	const handlenew14 = (no1) => {
		const jwb = no1.target.value;
		if (jwb.toUpperCase() === "C") {
			setNew14({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
			
		} else if (jwb === "") {
			setNew14({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setNew14({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	//1maret22

	const handlenew1 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "1") {
			setNew1({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
			setShownew1(true);
		} else if (jwb === "") {
			setNew1({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setNew1({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew2 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "2") {
			setNew2({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
			setShownew2(true);
		} else if (jwb === "") {
			setNew2({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setNew2({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew3 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "10") {
			setNew3({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
			setShownew3(true);
		} else if (jwb === "") {
			setNew3({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setNew3({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew4 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "3") {
			setNew4({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
			setShownew4(true);
		} else if (jwb === "") {
			setNew4({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setNew4({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew5 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "1") {
			setNew5({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
			setShownew5(true);
		} else if (jwb === "") {
			setNew5({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setNew5({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew6 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "15") {
			setNew6({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
			setShownew6(true);
		} else if (jwb === "") {
			setNew6({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setNew6({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew7 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setNew7({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
			setShownew7(true);
		} else if (jwb === "") {
			setNew7({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setNew7({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew8 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setNew8({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
			setShownew8(true);
		} else if (jwb === "") {
			setNew8({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setNew8({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew8a = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "45000") {
			setNew8a({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			});
			setShownew8a(true);
		} else if (jwb === "") {
			setNew8a({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setNew8a({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handlenew8b = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "25000") {
			setNew8b({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			});
			setShownew8b(true);
		} else if (jwb === "") {
			setNew8b({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setNew8b({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handlenew8c = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setNew8c({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			});
		} else if (jwb === "") {
			setNew8c({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setNew8c({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handlenew9 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "10,0") {
			setNew9({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
			setShownew9(true);
		} else if (jwb === "") {
			setNew9({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setNew9({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew9a = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,5") {
			setNew9a({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
			setShownew9a(true);
		} else if (jwb === "") {
			setNew9a({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setNew9a({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handlenew10 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "4") {
			setNew10({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
			setShownew10(true);
		} else if (jwb === "") {
			setNew10({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setNew10({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};

	//batasbaru9januari2022//
	const handleform1 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "10") {
			setForm1({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm1({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm1({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform2 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setForm2({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm2({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm2({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform3 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "10,0") {
			setForm3({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm3({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm3({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handleform4 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setShow1(true);
			setForm4({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm4({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm4({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform5 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "5") {
			setShow2(true);
			setForm5({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm5({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm5({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform6 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,5") {
			setShow3(true);
			setForm6({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm6({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm6({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform7 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "5") {
			setForm7({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm7({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm7({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform8 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setForm8({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm8({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm8({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform9 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "5,0") {
			setForm9({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm9({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm9({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform10 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setShow4(true);
			setForm10({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm10({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm10({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform11 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "15") {
			setShow5(true);
			setForm11({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm11({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm11({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform12 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,15") {
			setShow6(true);
			setForm12({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm12({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm12({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handleform13 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "3") {
			setShow7(true);
			setForm13({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm13({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm13({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform14 = (no1) => {
		const jwb = no1.target.value;
		if (jwb=== "5,0") {
			setShow8(true);
			setForm14({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm14({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm14({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform14a = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,15") {
			setShow8a(true);
			setForm14a({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm14a({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm14a({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform15 = (no1) => {
		const jwb = no1.target.value;
		if (jwb.toUpperCase() === "E") {
			setShow9(true);
			setForm15({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm15({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm15({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform16 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "4,3") {
			setShow10(true);
			setForm16({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm16({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm16({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform17 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,5") {
			setShow11(true);
			setForm17({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm17({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm17({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const [ukuranH,setUkuranH]=useState(19)
	const [ukuranP,setUkuranP]=useState(15)
	const sizeplus =()=>{
		setUkuranH(ukuranH+1)
		setUkuranP(ukuranP+1)
	}
	const sizemin =()=>{
		setUkuranH(ukuranH-1)
		setUkuranP(ukuranP-1)
	}
	return (
		<div className="container">
		<div className="d-flex justify-content-end">
		<button className="btnplus" onClick={sizeplus}><h6>A<sub>+</sub></h6></button>
		<button className="btnplus" onClick={sizemin}><h6>A<sub>-</sub></h6></button>
		</div>
			<div
				style={{
					marginTop: "1.5rem",
					color: "#2d8659",
				}}
			>
				<h5 style={{fontSize:`${ukuranH}px`}}>A. Metode Uji Titik Pojok</h5>
			</div>
			<div
				style={{
					textIndent: "2rem",
					width: "100%",
					textAlign: "justify",
					lineHeight: "35px",
					fontSize: `${ukuranP}px`
				}}
				className="col-sm-12 mt-3"
			>
				<p>
					Metode Uji Titik Pojok adalah suatu metode dengan mensubstitusikan
					titik-titik koordinat pada suatu daerah himpunan penyelesaian ke fungsi
					tujuannya atau disebut juga fungsi objektif. Nilai maksimum berarti
					nilai paling besar yang kita ambil, begitu juga untuk nilai minimum
					berarti nilai paling kecil yang kita ambil. Berikut langkah-langkah
					menentukan nilai optimum fungsi objektif dengan menggunakan metode uji
					titik pojok:
				</p>
			</div>
			<ul style={{ lineHeight: "35px", fontSize:`${ukuranP}px` }}>
				<li>
					Tentukan fungsi kendala dan fungsi objektif dari masalah program
					linear.{" "}
				</li>
				<li>
					Gambarlah daerah penyelesaian dari fungsi kendala di dalam masalah
					program linear. (Ingat kembali pada materi sebelumnya dalam
					menggambarkan daerah penyelesaian!) Tentukan titik-titik koordinat dalam
					daerah penyelesaian tersebut.
				</li>
				<li>
					Substitusikan koordinat  ke dalam fungsi
					objektif.
				</li>
				<li>
					Bandingkan setiap nilai-nilai fungsi objektif tersebut. Untuk mencari
					nilai maksimum maka pilih fungsi{" "}
					<b>
						<i>f(x,y)</i>
					</b>{" "}
					yang menghasilkan nilai terbesar. Sedangkan, untuk mencari nilai
					minimum maka pilih fungsi{" "}
					<b>
						<i>f(x,y)</i>
					</b>{" "}
					yang menghasilkan nilai terkecil.
				</li>
			</ul>
		
			<div className="d-grid gap-2">
				<button
					onClick={() => clickSetChSoal0()}
					className="btn btn-outline-success border-success shadow rounded"
				>
					{" "}
					<h6
						style={{
							animation: "scrollTop 0.3s alternate ease infinite",
						}}
					>
						Contoh Soal
					</h6>
				</button>
			</div>
			{chsoal0 ? <Ctp ukuranH={ukuranH} ukuranP={ukuranP} /> : null}
			<p style={{fontSize:`${ukuranP}px`}} className="text-center mt-2 mb-2">
				Setelah membaca dan memahami contoh soal di atas, selanjutnya kerjakan
				latihan di bawah ini !
			</p>
			<div className="row">
				<div className="col">
					<div
						className="card mt-2 mb-2 border-success"
						style={{ borderRadius: "20px" }}
					>
						<div
							style={{ backgroundColor: "#40bf80", borderRadius: "20px" }}
							className="card-header"
						>
							<h6 style={{fontSize:`${ukuranH}px`}} className="text-white text-center">Petunjuk Pengerjaan</h6>
						</div>
						<div className="card-body">
							<ol style={{fontSize:`${ukuranP}px`}}>
								<li>Perhatikan dengan teliti !</li>
								<li>Kalian harus mengisi form yang kosong</li>
								<li>
									Apabila benar maka border form akan berwarna hijau, kemudian
									akan tampil lanjutannya
								</li>
								<li>Apabila salah maka border form akan berwarna merah</li>
							</ol>
						</div>
					</div>
				</div>
			</div>
			<div className="d-grid gap-2">
				<button
					onClick={() => clickSetChSoal1()}
					className="btn btn-outline-success border-success shadow rounded"
				>
					{" "}
					<h6
						style={{
							animation: "scrollTop 0.3s alternate ease infinite",
						}}
					>
						Latihan Soal
					</h6>
				</button>
			</div>
			{chsoal1 ? (
				<div>
					<div
						className="mt-2"
						style={{
							margin: "auto",
							lineHeight: "35px",
							textAlign: "justify",
							width: "100%",
							borderStyle: "solid",
							borderColor: "#2d8659",
							borderRadius: "25px",
							boxShadow: "5px 5px #888887",
						}}
					>
						<div
							style={{
								width: "80%",
								margin: "auto",
							}}
						>
							<p
								style={{
									textIndent: "2rem",
									width: "100%",
									textAlign: "justify",
									lineHeight: "35px",
									fontSize:`${ukuranP}px`
								}}
							>
								Sebuah pabrik farmasi menyediakan dua jenis campuran L dan M.
								bahan-bahan dasar yang terkandung dalam setiap Kilogram campuran
								L dan M dapat dilihat pada tabel berikut ini
							</p>
						</div>
						<div className="d-flex justify-content-center">
							<MediaQuery minWidth={476} maxWidth={1824}>
								<div style={{ width: "90%" }}>
									<table
										className="table"
										style={{
											border: "2px solid green",
											borderCollapse: "collapse",
											width: "100%",
											textAlign: "center",
										}}
									>
										<tr>
											<th
												scope="col"
												style={{
													border: "2px solid green",
												}}
											>
												Pembatas
											</th>
											<th
												scope="col"
												style={{
													border: "2px solid green",
												}}
											>
												Bahan 1
											</th>
											<th
												scope="col"
												style={{
													border: "2px solid green",
												}}
											>
												Bahan 2
											</th>

											<th
												style={{
													border: "2px solid green",
												}}
											>
												Satuan
											</th>
										</tr>

										<tr>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												Campuran L
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												0,4
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												0,6
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												Kg
											</td>
										</tr>

										<tr>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												Campuran M
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												0,8
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												0,2
											</td>

											<td
												style={{
													border: "2px solid green",
												}}
											>
												Kg
											</td>
										</tr>
									</table>
								</div>
							</MediaQuery>
						</div>
						<div className="d-flex justify-content-center">
							<MediaQuery maxWidth={475}>
								<Scrollbar style={{ width: "80%", height: 200 }}>
									<div>
										<table
											className="table"
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
												width: "100%",
												textAlign: "center",
												fontSize:`${ukuranP}px`
											}}
										>
											<tr>
												<th
													scope="col"
													style={{
														border: "2px solid green",
													}}
												>
													Pembatas
												</th>
												<th
													scope="col"
													style={{
														border: "2px solid green",
													}}
												>
													Bahan 1
												</th>
												<th
													scope="col"
													style={{
														border: "2px solid green",
													}}
												>
													Bahan 2
												</th>

												<th
													style={{
														border: "2px solid green",
													}}
												>
													Satuan
												</th>
											</tr>

											<tr>
												<td
													style={{
														border: "2px solid green",
													}}
												>
													Campuran L
												</td>
												<td
													style={{
														border: "2px solid green",
													}}
												>
													0,4
												</td>
												<td
													style={{
														border: "2px solid green",
													}}
												>
													0,6
												</td>
												<td
													style={{
														border: "2px solid green",
													}}
												>
													Kg
												</td>
											</tr>

											<tr>
												<td
													style={{
														border: "2px solid green",
													}}
												>
													Campuran M
												</td>
												<td
													style={{
														border: "2px solid green",
													}}
												>
													0,8
												</td>
												<td
													style={{
														border: "2px solid green",
													}}
												>
													0,2
												</td>

												<td
													style={{
														border: "2px solid green",
													}}
												>
													Kg
												</td>
											</tr>
										</table>
									</div>
								</Scrollbar>
							</MediaQuery>
						</div>
						<p
							style={{
								textIndent: "2rem",
								width: "80%",
								textAlign: "justify",
								lineHeight: "35px",
								margin: "auto",
								fontSize:`${ukuranP}px`
							}}
						>
							Dari campuran L dan M tersebut akan dibuat campuran N. Campuran N
							tersebut sebanyak-banyaknya mengandung bahan 1 sebanyak 4 Kg dan
							bahan 2 sebanyak 3Kg. Harga setiap Kilogram campuran L adalah Rp
							45.000,00 dan setiap campuran M adalah Rp 25.000,00. Tentukanlah
							model matematika dari persamaan di atas jika biaya total untuk
							membuat campuran N diharapkan bisa semurah-murahnya!
						</p>
						<div
							style={{
								color: "green",
								display: "flex",
								justifyContent: "space-between",
								width: "10%",
								marginLeft: "20px",
							}}
						>
							<div
								style={{
									width: "5px",
									height: "5px",
									animation: "scrollTop 0.3s alternate ease infinite",
								}}
							>
								<SkipNextIcon />
							</div>
							<p
								style={{ marginLeft: "22px", cursor: "pointer" }}
								onClick={clickSetJawaban1}
							>
								<strong>
									<u>Jawaban</u>
								</strong>
							</p>
							<div
								style={{
									width: "5px",
									height: "5px",
									animation: "scrollTop 0.2s alternate ease infinite",
								}}
							>
								<SkipPreviousIcon />
							</div>
						</div>
						{jawaban1 ? (
							<div style={{ margin: "auto", width: "80%", lineHeight: "35px" }}>
								<ol style={{fontSize:`${ukuranP}px`}}>
									<li>
										Pertama kita memisalkan x adalah banyaknya bahan 1 sedangkan
										y adalah banyaknya bahan 2
									</li>
									<li>
										Melalui tabel pada soal, dapat diperoleh bahwa model
										matematika sebagai berikut:
									</li>
									<li>
										Kita buat dalam bentuk pertidaksamaan seperti berikut{" "}
									</li>
									<p>
										<ul>
											<li>Pertama pada Campuran L</li>
											<li>
												<InlineMath math="0,4x + 0,8y ≤ 4 " /> &nbsp; Agar
												memudahkan kita, mari kita kalikan semua koefisien dan
												konstanta dengan 2.5
											</li>
											<p className="text-center alert alert-warning">
												Coba kamu isi form di bawah ini!
											</p>
											<li>
												<input type="text" style={new1} onChange={handlenew1} />{" "}
												<InlineMath math="x + " /> &nbsp;
												<input type="text" style={new2} onChange={handlenew2} />
												<InlineMath math="y ≤ " />
												&nbsp;
												<input
													type="text"
													style={new3}
													onChange={handlenew3}
												/>{" "}
											</li>
											<li>Selanjutnya pada Campuran M</li>
											<li>
												{" "}
												<InlineMath math="0,6x + 0,2y ≤ 3  " /> &nbsp; Agar
												memudahkan kita, mari kita kalikan semua koefisien dan
												konstanta dengan 5{" "}
											</li>
											<p className="text-center alert alert-warning">
												Coba kamu isi form di bawah ini!
											</p>
											<li>
												<input type="text" style={new4} onChange={handlenew4} />{" "}
												<InlineMath math="x + " /> &nbsp;
												<input type="text" style={new5} onChange={handlenew5} />
												<InlineMath math="y ≤ " />
												&nbsp;
												<input
													type="text"
													style={new6}
													onChange={handlenew6}
												/>{" "}
											</li>
										</ul>
									</p>
									{shownew1 &&
									shownew2 &&
									shownew3 &&
									shownew4 &&
									shownew5 &&
									shownew6 ? (
										<>
											<li>
												Karena tidak mungkin banyaknya Bahan1 dan Bahan2 itu
												negatif, sehingga dapat dituliskan x ≥{" "}
												<input type="text" style={new7} onChange={handlenew7} />{" "}
												dan y ≥{" "}
												<input type="text" style={new8} onChange={handlenew8} />
											</li>
											{shownew7 && shownew8 ? (
												<>
													<li>
														Sehingga kita mendapatkan fungsi kendala adalah{" "}
														<InlineMath math=" x + 2y ≤ 10" />,{" "}
														<InlineMath math="3x + y ≤ 15" />,{" "}
														<InlineMath math="x ≥ 0" />, dan{" "}
														<InlineMath math=" y ≥ 0" />. Sedangkan untuk fungsi
														objektif adalah{" "}
														<InlineMath math="z = " />	<input type="text" style={new8a} onChange={handlenew8a} /> <InlineMath math="x + " /> <input type="text" style={new8b} onChange={handlenew8b} /><InlineMath math=" y " />
													</li>
												{shownew8a&&shownew8b?
												<>
													<li>
													Selanjutnya kita mencari titik potong
																				pada sumbu <InlineMath math="\space x \space" /> dan pada sumbu <InlineMath math="\space y \space" /> &nbsp;
																		pada persamaan
														 <InlineMath math="\space x + 2y = 10" />{" "}
												
													</li>
													<p>
														<MediaQuery minWidth={476} maxWidth={1824}>
															<table
																style={{ width: "100%", textAlign: "center" }}
																className="table"
															>
																<tr>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		x
																	</th>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		y
																	</th>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		(x,y)
																	</th>
																</tr>
																<tr>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handleform1}
																			style={form1}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handleform2}
																			style={form2}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		(
																		<input
																			type="text"
																			onChange={handleform3}
																			style={form3}
																			placeholder="(...,...)"
																		/>)
																	</td>
																</tr>
																<tr>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handleform4}
																			style={form4}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handleform5}
																			style={form5}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>(
																		<input
																			type="text"
																			onChange={handleform6}
																			style={form6}
																			placeholder="(...,...)"
																		/>)
																	</td>
																</tr>
															</table>
														</MediaQuery>
														<MediaQuery maxWidth={475}>
															<table
																style={{ width: "100%", textAlign: "center" }}
																className="table"
															>
																<tr>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		x
																	</th>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		y
																	</th>
																	<th
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		(x,y)
																	</th>
																</tr>
																<tr>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handleform1}
																			style={form1}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handleform2}
																			style={form2}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handleform3}
																			style={form3}
																			placeholder="(...,...)"
																		/>
																	</td>
																</tr>
																<tr>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handleform4}
																			style={form4}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handleform5}
																			style={form5}
																		/>
																	</td>
																	<td
																		style={{
																			border: "2px solid green",
																		}}
																	>
																		<input
																			type="text"
																			onChange={handleform6}
																			style={form6}
																			placeholder="(...,...)"
																		/>
																	</td>
																</tr>
															</table>
														</MediaQuery>
													</p>

													{show1 && show2 && show3 ? (
														<div>
																<p className="text-center">Maka kita dapatkan :</p>
																	<div className="d-flex justify-content-center">
																		Titik Koordinat A = (<input type="text" onChange={handlenew9} style={new9} />) 
																	</div>
																	<div className="d-flex justify-content-center">
																		Titik Koordinat B = (<input type="text" onChange={handlenew9a} style={new9a} />) 
																	</div>
														
															{shownew9&&shownew9a ? (
																<>
																	<li>
																	Selanjutnya kita mencari titik potong
																				pada sumbu <InlineMath math="\space x \space" /> dan pada sumbu <InlineMath math="\space y \space" /> &nbsp;
																		pada persamaan
																		<InlineMath math="\space 3x + y = 15" />
																	</li>
																	<p>
																		<MediaQuery minWidth={476} maxWidth={1824}>
																			<table
																				style={{
																					width: "100%",
																					textAlign: "center",
																				}}
																				className="table"
																			>
																				<tr>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						x
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						y
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						(x,y)
																					</th>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform7}
																							style={form7}
																						/>
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform8}
																							style={form8}
																						/>
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>(
																						<input
																							type="text"
																							onChange={handleform9}
																							style={form9}
																						/>
																					)
																					</td>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform10}
																							style={form10}
																						/>
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform11}
																							style={form11}
																						/>
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>(
																						<input
																							type="text"
																							onChange={handleform12}
																							style={form12}
																						/>
																					)
																					</td>
																				</tr>
																			</table>
																		</MediaQuery>
																		<MediaQuery maxWidth={475}>
																			<table
																				style={{
																					width: "100%",
																					textAlign: "center",
																				}}
																				className="table"
																			>
																				<tr>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						x
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						y
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						(x,y)
																					</th>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform7}
																							style={form7}
																						/>
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform8}
																							style={form8}
																						/>
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform9}
																							style={form9}
																						/>
																					</td>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform10}
																							style={form10}
																						/>
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform11}
																							style={form11}
																						/>
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform12}
																							style={form12}
																						/>
																					</td>
																				</tr>
																			</table>
																		</MediaQuery>
																	</p>
																	{show4 && show5 && show6 ? (
																		<div>
																		<p className="text-center">Maka kita dapatkan :</p>
																	<div className="d-flex justify-content-center">
																		Titik Koordinat C = (<input type="text" onChange={handleform14} style={form14} />) 
																	</div>
																	<div className="d-flex justify-content-center">
																		Titik Koordinat D = (<input type="text" onChange={handleform14a} style={form14a} />) 
																	</div>
																			{show8&&show8a ? (
																				<div>
																			<div className="text-center alert alert-warning"><b>Petunjuk :</b> Kalian dapat melakukan zoom pada grafik seperti biasa</div>
																					<li>
																						Coba kamu kerjakan apa yang
																						diperintahkan pada grafik di bawah!
																					</li>
																					<div
																						style={{
																							display: "flex",
																							justifyContent: "center",
																						}}
																					>
																						<MediaQuery
																							minWidth={476}
																							maxWidth={1824}
																						>
																							<Iframe
																							scrolling="no" title="Latihan1TPoptimum" src="https://www.geogebra.org/material/iframe/id/hddqbufc/width/810/height/717/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false" width="810px" height="717px" allowFullScreen
																							></Iframe>
																						</MediaQuery>
																					</div>
																					<MediaQuery maxWidth={475}>
																						<Iframe
scrolling="no" title="Latihan1TPoptimum" src="https://www.geogebra.org/material/iframe/id/hddqbufc/width/810/height/717/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false" width="200px"
																							style={{ height: "200px" }} allowFullScreen
																						></Iframe>
																					</MediaQuery>
																			
																					<li>
																				
																												Untuk mencari titik koordinat 	<input
																							type="text"
																							onChange={handleform15}
																							style={form15}
																						/> maka gunakan metode eliminasi
																												atau subsitusi agar mendapatkan nilainya.
																												
																					
																					</li>
																					{show9 ? (
																						<div>
																							<div className="d-flex justify-content-center">
																								<MediaQuery
																									minWidth={476}
																									maxWidth={1824}
																								>
																									<TransformWrapper
																										defaultScale={1}
																									>
																										<TransformComponent>
																											<img
																												src={Lt1}
																												alt="tp1"
																											/>
																										</TransformComponent>
																									</TransformWrapper>
																								</MediaQuery>
																							</div>
																							<MediaQuery maxWidth={475}>
																								<TransformWrapper
																									defaultScale={1}
																								>
																									<TransformComponent>
																										<img
																											style={{
																												height: "200px",
																												width: "200px",
																											}}
																											src={Lt1}
																											alt="tp1"
																										/>
																									</TransformComponent>
																								</TransformWrapper>
																							</MediaQuery>
																							<li>
																								Maka kita mendapatkan nilai{" "}
																								<InlineMath math=" y = " />{" "}
																								<input
																									type="text"
																									onChange={handleform13}
																									style={form13}
																								/>
																							</li>
																							{show7 ? (
																								<>
																									<p>
																										<li>
																											Selanjutnya kita
																											substitusikan nilai y ke
																											dalam &nbsp;
																											<InlineMath math="x + 2y = 10" />
																										</li>
																										<ul>
																											<li>
																												<InlineMath math="x + 2(3) = 10" />
																											</li>
																											<li>
																												<InlineMath math="x + 6 = 10" />
																											</li>
																											<li>
																												<InlineMath math="x = 10-6 " />
																											</li>
																											<li>
																												<InlineMath math="x =  " />
																												<input
																													type="text"
																													style={new10}
																													onChange={handlenew10}
																												/>
																											</li>
																										</ul>
																									</p>
																									{shownew10 ? (
																										<>
																											<li>
																												Maka diperoleh titik
																												korrdinat E adalah (
																												<input
																													type="text"
																													onChange={
																														handleform16
																													}
																													style={form16}
																												/> )
																											</li>
																											{show10 ? (
																												<div>
																													<li>
																														Dari gambar daerah
																														penyelesaian di atas
																														maka didapatkan
																														titik-titik koordinat
																														sebagai berikut
																														 B(5,0), C(0,5) dan
																														E(4,3) Untuk
																														menentukan nilai
																														optimum,
																														substitusikan setiap
																														titik koordinat ke dalam
																														fungsi objektif
																														yaitu{" "}
																														<b>
																															<i>
																																z = 45.000x +
																																25.000y
																															</i>
																														</b>
																														.
																													</li>
																													<p className="text-center alert alert-warning">Coba lengkapi form di bawah ini!</p>
																													<p>
																														<ul>
																															<div className="d-flex justify-content-center">
																																<table
																																	className="table"
																																	style={{
																																		border:
																																			"2px solid green",
																																		borderCollapse:
																																			"collapse",
																																		width:
																																			"100%",
																																		textAlign:
																																			"center",
																																	}}
																																>
																																	<tr>
																																		<th
																																			scope="col"
																																			style={{
																																				border:
																																					"2px solid green",
																																			}}
																																		>
																																			Titik
																																			koordinat
																																		</th>
																																		<th
																																			scope="col"
																																			style={{
																																				border:
																																					"2px solid green",
																																			}}
																																		>
																																			<InlineMath math="z = 45000x + 25000y" />
																																		</th>
																																		<th
																																			scope="col"
																																			style={{
																																				border:
																																					"2px solid green",
																																			}}
																																		>
																																			Hasil
																																		</th>
																																	</tr>
																																	<tr>
																																		<td
																																			style={{
																																				border:
																																					"2px solid green",
																																			}}
																																		>
																																			 (0, 0)
																																		</td>
																																		<td
																																			style={{
																																				border:
																																					"2px solid green",
																																			}}
																																		>
																																			<InlineMath math=" 45.000(0) + 25.000(0)" />
																																		</td>
																																		<td
																																			style={{
																																				border:
																																					"2px solid green",
																																			}}
																																		>
																																			<input type="text" style={new8c} onChange={handlenew8c} />
																																		</td>
																																	</tr>
																																	
																																	<tr>
																																		<td
																																			style={{
																																				border:
																																					"2px solid green",
																																			}}
																																		>
																																			B (5,0)
																																		</td>
																																		<td
																																			style={{
																																				border:
																																					"2px solid green",
																																			}}
																																		>
																																			<InlineMath math=" 45.000(5) + 25.000(0)" />
																																		</td>
																																		<td
																																			style={{
																																				border:
																																					"2px solid green",
																																			}}
																																		>
																																			<input type="text" style={new12} onChange={handlenew12} />
																																		</td>
																																	</tr>
																																	<tr>
																																		<td
																																			style={{
																																				border:
																																					"2px solid green",
																																			}}
																																		>
																																			C (0,5)
																																		</td>
																																		<td
																																			style={{
																																				border:
																																					"2px solid green",
																																			}}
																																		>
																																			<InlineMath math=" 45.000(0) + 25.000(5)" />
																																		</td>
																																		<td
																																			style={{
																																				border:
																																					"2px solid green",
																																			}}
																																		>
																																			<input type="text" style={new13} onChange={handlenew13} />
																																		</td>
																																	</tr>
																																	<tr>
																																		<td
																																			style={{
																																				border:
																																					"2px solid green",
																																			}}
																																		>
																																			E (4 , 3)
																																		</td>
																																		<td
																																			style={{
																																				border:
																																					"2px solid green",
																																			}}
																																		>
																																			<InlineMath math=" 45.000(4) + 25.000(3)" />
																																		</td>
																																		<td
																																			style={{
																																				border:
																																					"2px solid green",
																																			}}
																																		>
																																			<input type="text" style={new11} onChange={handlenew11} />
																																		</td>
																																	</tr>
																																</table>
																															</div>
																														{shownew11&&shownew12&&shownew13?
																														<>
																																<li>
																																Dari ketiga
																																substitusi di
																																atas ditunjukkan
																																bahwa tiitk &nbsp;&nbsp;<input
																																	type="text"
																																	onChange={
																																		handlenew14
																																	}
																																	style={new14}
																																/> <InlineMath math="\space = (" />
																																<input
																																	type="text"
																																	onChange={
																																		handleform17
																																	}
																																	style={form17}
																																/> <InlineMath math=") \space" />
																																menghasilkan
																																nilai minimum di
																																antara titik
																																yang lainnya
																															</li>
																																{show11 ? (
																														<div>
																															<p className="text-center">
																																{" "}
																																<b>
																																	Jadi total
																																	biaya campuran
																																	N
																																	semurah-murahnya
																																	adalah Rp
																																	125.000,00.
																																</b>
																															</p>
																															<div className="d-flex justify-content-center mb-4">
		<Button variant="outlined" color="primary" onClick={handleClickOpenDialog}>
        Tonton Video Cara Mengerjakan Mari Mencoba
      </Button>
	  <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Cara Pengerjaan !"}</DialogTitle>
        <DialogContent>
		<div className="d-flex justify-content-center">
															
																<MediaQuery minWidth={476} maxWidth={1824}>
																<VideoPlayer 
																src={Caratp}
																width="800"
																height="500"
																/>
																</MediaQuery>
																<MediaQuery maxWidth={475}>
																<VideoPlayer 
																src={Caratp}
																width="300"
																height="100"
																/>
																</MediaQuery>
															
														</div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary" autoFocus>
            Tutup
          </Button>
        </DialogActions>
      </Dialog>
		</div>
																															<div className="d-flex justify-content-center">
																																<button
																																	className="btn btn-outline-primary mb-2"
																																	onClick={
																																		openMencobaDialog
																																	}
																																>
																																	Mari Mencoba
																																</button>
																															</div>
																														</div>
																													) : null}
																														</>
																														:null}
																													
																														</ul>
																													</p>
																											
																												</div>
																											) : null}
																										</>
																									) : null}
																								</>
																							) : null}
																						</div>
																					) : null}
																				</div>
																			) : null}
																		</div>
																	) : null}
																</>
															) : null}
														</div>
													) : null}
												</>
												:null}
												</>
											) : null}
										</>
									) : null}
								</ol>
							</div>
						) : null}
						<Dialog
							fullScreen
							open={openmencobadialog}
							onClose={closemencobaDialog}
							TransitionComponent={Transition}
						>
							<AppBar className={classes.appBar}>
								<Toolbar>
									<IconButton
										edge="start"
										color="inherit"
										onClick={closemencobaDialog}
										aria-label="close"
									>
										<CloseIcon />
									</IconButton>
									<h4 className={classes.title}>
										Mari Mencoba Nilai Optimum Titik Pojok
									</h4>
								</Toolbar>
							</AppBar>

							<Marimencoba />
						</Dialog>
					</div>
				</div>
			) : null}
		</div>
	);
};

export default Part2;
